import { Dialog, DialogBackdrop, DialogPanel }  from '@headlessui/react';
import dayjs                from 'dayjs';

function __numberToFloat(num) {
    return parseFloat(num).toFixed(1);
}

const handleDateChange = (date, periodUnity) => {

    if (periodUnity === 'day') {
        return dayjs(date, 'DD/MM/YY').format('DD/MM/YY')
    }

    if (periodUnity === 'month') {
        return dayjs(date, "YYYY-MM-DD").format('MM/YY')
    }

    if (periodUnity === 'year') {
        return dayjs(date, "YYYY-MM-DD").format('YYYY')
    }

}

export default function PxoSelectDemandModal ({
    isOpen, 
    onClose, 
    onSubmit, 
    demandData, 
    selectedDate, 
    selectedHorizonTypeId,
    toogleSelectDemandForPxo,
    selectedDemandPost
}) {

    return(

        <Dialog open={isOpen} onClose={onClose} className="relative z-[100] ">

            <DialogBackdrop 
                transition 
                className="fixed inset-0 bg-bg-backdrop transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"
            />
            
            <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
                
                <div className=" flex min-h-full items-end justify-center p-1 text-center sm:items-center sm:p-0">
                    
                    <DialogPanel 
                        transition 
                        className="w-[707px] min-h-[505px]relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in sm:my-8  data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95"
                    >   
                        
                        <div className="app-container">
                            
                            {/* #region header */}
                            
                            <header className="bg-azul-profundo-m flex justify-between items-center pl-4 pr-1 py-3">
                            
                                <h2 className="text-white text-[1rem] leading-7 font-semibold">Inserir Demanda</h2>
                                <button onClick={onClose} className="text-[1.2rem] text-white hover:text-gray-200 pr-2">×</button>
                            
                            </header>

                            {/* #endregion */}

                            <div className="px-4 pb-4 pt-2 sm:pb-4 flex flex-col gap-[10px] ">
                                
                                <table className='table-pattern-sistem w-full borda-cinza mt-4'>
                                
                                    <thead className='bg-neutro'>
                                        <tr>

                                            <th></th>
                                            <th>Tipo</th>
                                            <th>Data</th>
                                            <th>Versão</th>
                                            <th>Ferrovia</th>
                                            <th>Usuário</th>
                                            <th>Status</th>

                                        </tr>
                                    </thead>
                                    <tbody>

                                        {Array.isArray(demandData) && demandData.length > 0 ? ( 
                                            
                                            demandData.map((data) => (
                                                
                                                <tr key={data.id} className='row hover:cursor-pointer hover:bg-neutro'>

                                                    <td>
                                                        
                                                        <input 
                                                            id={`canEdit-${data.id}`}
                                                            type="checkbox" 
                                                            className="w-4 h-4 !m-auto !block ![appearance:auto] text-blue-600 bg-gray-100 border-gray-300 rounded-sm"
                                                            
                                                            checked={
                                                                selectedDemandPost[data.ownerDemandRailway.id] === data.id ? true : false
                                                            }                   
                                                            
                                                            onChange={() => {
                                                                toogleSelectDemandForPxo(
                                                                    data.ownerDemandRailway.id,
                                                                    data.id, 
                                                                    (selectedDemandPost[data.ownerDemandRailway.id] === data.id) ? false : true
                                                                )}}
                                                        />

                                                    </td>
                                                    <td>{data.ownerDemandHorizon.ownerHorizonOfPlan.name}</td>
                                                    <td>
                                                        {handleDateChange(
                                                            data.referenceDate, 
                                                            data.ownerDemandHorizon.ownerHorizonOfPlan.dateInputFilterFormat
                                                        )}
                                                    </td>
                                                    <td>{__numberToFloat(data.version)}</td>
                                                    <td>{data.ownerDemandRailway.name}</td>
                                                    <td>{data.ownerAuthor.fullName}</td>
                                                    <td dangerouslySetInnerHTML={{ __html:  data.ownerDemandPostStatus.icon}}></td>

                                                </tr>
                                                           
                                            ))
                                        
                                            
                                        ):(
                                            <tr><td colSpan="7" className="text-center p-4"><p>Sem dados</p></td></tr>
                                        )}  

                                    </tbody>
                                </table>
                                               
                            </div>

                            {/* #region footer */}            
                            <footer className="w-full bg-gray-50 px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6">
                                
                                <button 
                                    type="submit" 
                                    onClick={() => onSubmit()} 
                                    className="btn btn-azul-prof sm:ml-3 w-[50%] text-[1.125rem]"
                                >
                                    Salvar
                                </button>

                                <button 
                                    type="button"   
                                    onClick={onClose} 
                                    className="btn btn-cinza w-[50%] text-[1.125rem]"
                                >
                                    Cancelar
                                </button>

                            </footer>
                            {/* #endregion */}
                                        
                        </div>
                        
                    </DialogPanel>
                </div>
            </div>
        </Dialog>

    )

}
